import { useCallback } from 'react'

export interface MarkBus {
  mark(type: string, detail?: Record<string, unknown>): void
  navigate(path: string): void
}

declare global {
  interface Window {
    __usability?: MarkBus
  }
}

export function installMarkBus(bus: MarkBus): void {
  window.__usability = bus
}

export function uninstallMarkBus(): void {
  delete window.__usability
}

/**
 * Returns a stable callback that emits a semantic mark to the active capture
 * session, or does nothing when no session is recording. Safe to call from any
 * component regardless of whether the tool is mounted.
 */
export function useUsabilityMark(): (type: string, detail?: Record<string, unknown>) => void {
  return useCallback((type: string, detail?: Record<string, unknown>) => {
    window.__usability?.mark(type, detail)
  }, [])
}
